import MuiAlert from "@mui/material/Alert";
import MuiSnackbar from "@mui/material/Snackbar";
import Stack from "@mui/material/Stack";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { closeAlert } from "@/redux/actions";

const Alert = React.forwardRef((
    props,
    ref,
) => (
    <MuiAlert
        {...props}
        elevation={6}
        ref={ref}
        variant="filled"
    />
));

export const Snackbar = () => {
    const dispatch = useDispatch();

    const duration = useSelector(({ alertReducer }) => alertReducer.duration);

    const message = useSelector(({ alertReducer }) => alertReducer.message);

    const open = useSelector(({ alertReducer }) => alertReducer.open);

    const status = useSelector(({ alertReducer }) => alertReducer.status);

    const closeSnackbarHandler = () => dispatch(closeAlert());

    return (
        <Stack spacing={2}>
            <MuiSnackbar
                autoHideDuration={duration || 3000}
                open={open}
                anchorOrigin={{
                    horizontal: "center",
                    vertical: "top",
                }}
                onClose={closeSnackbarHandler}
                onDurationChange={closeSnackbarHandler}
            >
                <Alert
                    severity={status}
                    onClose={closeSnackbarHandler}
                >
                    {message}
                </Alert>
            </MuiSnackbar>
        </Stack>
    );
};
